import { useForceUpdate } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

interface IIntervalProps {
    interval: number;
    children: JSX.Element | (() => JSX.Element);
    update?: () => any;
}

export function Interval(props: IIntervalProps) {
    const [, setTime] = useState(Date.now());
    const forceUpdate = useForceUpdate();

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(Date.now());
            props.update ? props.update() : forceUpdate();
        }, props.interval);
        return () => {
            clearInterval(interval);
        };
    }, [props, forceUpdate]);

    if (typeof props.children === 'function') {
        return props.children();
    } else {
        return props.children;
    }
}
